import DisplayContainer from "../components/DisplayContainer.ts";
import {Graphics,Container,Sprite,Text} from "pixi.js";
import DisplayContainerOptions from "../interfaces/DisplayContainerOptions.ts";
import AppModel from "../models/AppModel.ts";
import { Input } from "@pixi/ui";
import { DropShadowFilter } from "pixi-filters/drop-shadow";

export default class Menu extends DisplayContainer
{
    //--------------------------------------------------------------------------
    //
    //  Properties
    //
    //--------------------------------------------------------------------------

    //----------------------------------
    //  Private:
    //----------------------------------

    private bg:Graphics;
    private model: AppModel;
    private continueInput: Input;
    private readyFunction: Function;

    //--------------------------------------------------------------------------
    //
    //  Constructor
    //
    //--------------------------------------------------------------------------

    constructor(readyFunction: Function, options?:DisplayContainerOptions)
    {
        super();
        this.readyFunction = readyFunction;
        if(options)
        {
            this.options = options;
        }
        else
        {
            this.setDefaultOptions();
        }
        this._init();
    }

    //--------------------------------------------------------------------------
    //
    //  Methods
    //
    //--------------------------------------------------------------------------

    //----------------------------------
    //  Private:
    //----------------------------------

    private _init()
    {
        this.label = "Menu";
        this.model = AppModel.getInstance();
        if(this.options.autoCreate)
        {
            this.create(this.options.showAfterCreate);
        }
    }

    private createBackground()
    {
        this.bg = new Graphics();
        this.bg.fill(0xFFFFFF);//.fill(0x3498db);
        this.bg.rect(0, 0, this.model.stageWidth, this.model.stageHeight);
        this.bg.fill();
        this.addChild(this.bg);
    }

    private createContinueOption()
    {
        let continueContainer = new Container();
        this.addChild(continueContainer);

        let continueText = new Text({ 
            label: "Continue txt",
            text: "Continue",
            style: {
                fontFamily: "Arial",
                fontSize: 36,
                //fill: "white"
            }
        });
        continueText.x = this.width / 4 - continueText.width / 2;
        continueText.y = 80;
        continueContainer.addChild(continueText);

        let assessmentText = new Text({
            label: "Assessment txt",
            text: "Assessment",
            style: {
                fontFamily: "Arial",
                fontSize: 36,
                //fill: "white"
            }
        });
        assessmentText.x = this.width / 4 - assessmentText.width / 2;
        assessmentText.y = 120;
        continueContainer.addChild(assessmentText);

        let inputBg = new Graphics();
        inputBg.fill(0xE7E9EB);
        inputBg.rect(0, 0, 300, 40);
        inputBg.fill();
        continueContainer.addChild(inputBg);

        this.continueInput = new Input({
            bg: inputBg,
            placeholder: "User Id",
            padding: 11
        });
        this.continueInput.x = 191;
        this.continueInput.y = 180;
        continueContainer.addChild(this.continueInput);

        let continueBtn = Sprite.from("continueBtn");
        continueBtn.x = this.width / 4 - continueBtn.width / 2;
        continueBtn.y = 300;
        continueBtn.cursor = "pointer";
        continueBtn.interactive = true;
        //continueBtn.filters = [new DropShadowFilter({
        //    blur: 6,
        //    color: 0x000000,
        //    alpha: 0.25
        //})];
        continueBtn.onpointerup = this.handleContinueClick;
        continueContainer.addChild(continueBtn);
    }

    private createStartOption() {
        let startContainer = new Container();
        startContainer.x = this.width / 2;
        this.addChild(startContainer);

        let continueText = new Text({
            label: "Start txt",
            text: "Start",
            style: {
                fontFamily: "Arial",
                fontSize: 36,
                //fill: "white"
            }
        });
        continueText.x = this.width / 4 - continueText.width / 2;
        continueText.y = 80;
        startContainer.addChild(continueText);

        let assessmentText = new Text({
            label: "Assessment txt",
            text: "Assessment",
            style: {
                fontFamily: "Arial",
                fontSize: 36,
                //fill: "white"
            }
        });
        assessmentText.x = this.width / 4 - assessmentText.width / 2;
        assessmentText.y = 120;
        startContainer.addChild(assessmentText);

        let startBtn = Sprite.from("startBtn");
        startBtn.x = this.width / 4 - startBtn.width / 2;
        startBtn.y = 300;
        startBtn.cursor = "pointer";
        startBtn.interactive = true;
        //continueBtn.filters = [new DropShadowFilter({
        //    blur: 6,
        //    color: 0x000000,
        //    alpha: 0.25
        //})];
        startBtn.onpointerup = this.handleStartClick;
        startContainer.addChild(startBtn);
    }

    private createNewOption() {
        let header = new Text({
            label: "Header",
            text: "Speech Recognition Validation Test",
            style: {
                fontFamily: "Arial",
                fontSize: 36,
                //fill: "white"
            }
        });

        header.x = this.width / 2 - header.width / 2;
        header.y = 80;
        this.addChild(header);

        let inputBg = new Graphics();
        inputBg.fill(0xE7E9EB);
        inputBg.rect(0, 0, 200, 40);
        inputBg.fill();
        this.addChild(inputBg);

        this.continueInput = new Input({
            bg: inputBg,
            placeholder: "User Number",
            padding: 11
        });
        this.continueInput.x = this.width / 2 - 100;
        this.continueInput.y = 220;
        this.addChild(this.continueInput);

        let btnContainer = new Container();
        let btnBg = new Graphics();
        btnBg.fill(0xFFFFFF);
        btnBg.roundRect(0, 0, 200, 50, 10);
        btnBg.fill();
        btnBg.stroke({ color: 0x3498db, width: 4 });
        btnContainer.addChild(btnBg);
        const dpr = window.devicePixelRatio || 1;
        btnBg.filters = [new DropShadowFilter({ resolution: dpr })];
        btnContainer.x = this.width / 2 - 100;
        btnContainer.y = 300;
        let btnText = new Text({
            label: "Start",
            text: "Enter Test",
            style: {
                fontFamily: "Arial",
                fontSize: 28,
                //fill: "white"
            }
        });
        btnText.x = btnBg.width / 2 - btnText.width / 2;
        btnText.y = 10;
        btnContainer.addChild(btnText);
        btnContainer.interactive = true;
        btnContainer.cursor = "pointer";
        btnContainer.onpointerup = this.handleContinueClick;
        this.addChild(btnContainer);
    }

    private handleContinueClick = (event): void => {
        const num = Number(this.continueInput.value != "" ? this.continueInput.value : "empty");
        const isInt = !isNaN(num) && Number.isInteger(num);
        if (isInt) {
            fetch(`/Speech/getExistingUser?userId=${num}`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`Error getting existing user: ${response.status}`)
                    }
                    return response.json();
                }).then(data => {
                    if (data.exists) {
                        this.readyFunction(num);
                    } else {
                        alert('That User Number was not found in the system.');
                    }
                }).catch(e => {
                    console.error(e);
                    debugger;
                });
        } else {
            alert('Invalid User Id');
        }
    }

    private handleStartClick = (event):void => {
        fetch("/Speech/getNewUser")
        .then(response => {
            if (!response.ok) {
                throw new Error(`Error getting new user: ${response.status}`)
            }
            return response.json();
        }).then(data => {
            alert(`Your User Id if you want to continue your assessment later is: ${data.id}`);
            this.readyFunction(data.id);
        }).catch(e => {
            console.error(e);
            debugger;
        });
    }

    private setDefaultOptions():void
    {
        this.options = {
            autoCreate: true,
            showAfterCreate: true
        };
    }

    //----------------------------------
    //  Public:
    //----------------------------------

    public override create(showAfterCreate:boolean=true):void
    {
        this.createBackground();
        //this.createContinueOption();
        //this.createStartOption();
        this.createNewOption();
        if(showAfterCreate)
        {
            this.show();
        }
    }

    public override destroy():void
    {
        super.destroy();
    }
}